import React, { Component } from 'react';

import './style/AddAddressRadius.scss';

import iconClose from '../../../img/close.svg';

export default class LocaleBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fieldValue: '',
			arrayAddress: [],
			messageErrorField: '',
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		const { valueField } = this.props;
		this.setState({
			arrayAddress: valueField || this.getAddresFromAswers(),
		}, () => {
			this.updateValues();
		});
	}

	getAddresFromAswers() {
		const { answers } = this.props;
		return answers
			.filter(ans => (ans.attributes.content))
			.map((ans) => {
				const content = JSON.parse(ans.attributes.content);
				return {
					nameAddress: `${content.endereco}, ${content.cidade}, ${content.estado}`,
					type: 'Loja',
					valueRange: 10,
					id: Math.random(),
				};
			});
	}

	changeRangeAddress = idx => (evt) => {
		const { arrayAddress } = this.state;

		const newShareholders = arrayAddress.map((shareholder, sidx) => {
			if (idx !== sidx) return shareholder;
			return { ...shareholder, valueRange: evt.target.value };
		});

		this.setState({ arrayAddress: newShareholders }, this.updateValues);
	};

	handleRemoveField = (id) => {
		const { arrayAddress } = this.state;

		const list = arrayAddress.filter(item => item.id !== id);

		this.setState({
			arrayAddress: [...list],
		}, this.updateValues);
	};

	addAddress = () => {
		const { fieldValue, typeAddressRadius } = this.state;

		if (!typeAddressRadius) {
			this.setState({
				messageErrorField: 'É necessário inserir o tipo de endereço!',
			});
			return false;
		}

		if (!fieldValue) {
			this.setState({
				messageErrorField: 'É necessário inserir o endereço!',
			});
			return false;
		}

		this.setState(prevState => ({
			arrayAddress: [...prevState.arrayAddress, {
				type: typeAddressRadius,
				nameAddress: fieldValue,
				valueRange: 10,
				id: Math.random(),
			}],
			messageErrorField: '',
		}), this.updateValues);
		return false;
	};

	updateValues() {
		const {
			arrayAddress,
		} = this.state;

		const { nameField, onGetValueField } = this.props;

		if (arrayAddress.length < 1) {
			this.setState({
				messageErrorField: 'Por favor, para avançar, selecione uma localização e defina um raio.',
			});
		}

		onGetValueField(nameField, arrayAddress);
	}

	handleChange(evt) {
		this.setState({
			[evt.target.name]: evt.target.value,
		}, this.updateValues);
	}

	render() {
		const { classContainer } = this.props;
		const { fieldValue, arrayAddress, messageErrorField } = this.state;

		return (
			<div className="component-add-address-radius">
				<div className={`component-question-data ${classContainer}`}>
					<p className="description-label">* Selecione o tipo, escreva o local e clique em incluir</p>
					<div className="row-add-address mt-3">
						<div className="select-container">
							<select className="form-control" type="select" name="typeAddressRadius" onChange={this.handleChange}>
								<option
									className="form-check-input css-checkbox"
									type="checkbox"
									value=""
									id="add-address-radius0"
									name="add-address-radius"
								>Tipo
								</option>
								<option
									className="form-check-input css-checkbox"
									type="checkbox"
									value="Região"
									id="add-address-radius1"
									name="add-address-radius"
								>Região
								</option>
								<option
									className="form-check-input css-checkbox"
									type="checkbox"
									value="Bairro"
									id="add-address-radius3"
									name="add-address-radius"
								>Bairro
								</option>
								<option
									className="form-check-input css-checkbox"
									type="checkbox"
									value="Cidade"
									id="add-address-radius4"
									name="add-address-radius"
								>Cidade
								</option>
								<option
									className="form-check-input css-checkbox"
									type="checkbox"
									value="Estado"
									id="add-address-radius5"
									name="add-address-radius"
								>Estado
								</option>
							</select>
						</div>

						<input type="text" name="fieldValue" value={fieldValue} onChange={this.handleChange} />
						<button type="button" onClick={this.addAddress.bind(this)}>INCLUIR</button>
					</div>
					{ (arrayAddress)
						? (
							<div className="mt-4">
								<p className="description-label">* Defina um raio a partir dos locais escolhidos:</p>
								<div className="container-card mt-3">
									{ arrayAddress.map((address, idx) => (
										<div className="card-address" key={Math.random()}>
											<div className="header-card-address">
												<span className="text-truncate">
													<b>{address.type}: </b>
													{address.nameAddress}
												</span>

												{/* eslint-disable-next-line max-len */}
												{/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
												<img
													src={iconClose}
													alt="Ícone de fechar"
													className="icon-close"
													onKeyDown={this.handleRemoveField.bind(this, address.id)}
													onClick={this.handleRemoveField.bind(this, address.id)}
												/>
											</div>
											<div className="content-card-address">
												<p className="label-description-range">Defina o raio:</p>
												<div className="label-range">
													<span>5</span>
													<span
														className="color-red"
													>{address.valueRange ? `${address.valueRange} km` : '10 km'}
													</span>
													<span>100</span>
												</div>

												<input
													type="range"
													value={address.valueRange ? address.valueRange : 10}
													onChange={this.changeRangeAddress(idx)}
													min="5"
													max="100"
												/>
											</div>
										</div>
									))}
								</div>
							</div>
						)

						: '' }
					<div className="help-block">{messageErrorField}</div>
				</div>
			</div>
		);
	}
}
